import { DEFAULT_PAGE_SIZE } from '@/components';
import { useDebouncedQueryStates } from '@/lib/nuqs';
import { parseAsInteger } from 'nuqs';

export const useUsersSnapshotQueryState = () => {
  return useDebouncedQueryStates({
    keyMap: {
      page: parseAsInteger.withDefault(1),
      pageSize: parseAsInteger.withDefault(DEFAULT_PAGE_SIZE),
    },
  });
};
